export default {
  purchaser: "",
  title: "",
  body: "",
  rating: 5,
  purchaserModel: null
};
